import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import { cn } from "@omni/utils/styles";
import React from "react";

export type CardFooterComponentProps = {};

export type CardFooterProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, CardFooterComponentProps, "div">;

const CardFooter = <T extends React.ElementType = "div">({
    className,
    tag,
    ...attributes
}: CardFooterProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const classes = cn(className, "card-footer");

    return (
        <Tag
            {...attributes}
            className={classes}
        />
    );
};

export { CardFooter };
